<template>
	<div>

		<dialogue
			:title="'Add Box'"
			:paragraph="box_dialogue_text"
			:button_names="['Yes','No']"
			:show="box_dialogue"
			v-on:dialogue="addBox"
			v-on:cancel="cancelBox"
		></dialogue>

		<checkitem
			:show=checkOpen
			:isIn=checkIsIn
			:itemId=itemId
			v-on:cancel="closeCheck"
			v-on:dialogue="checkItem"
		></checkitem>

		<layout-1
			:table_name="'Inventory'"
			:filter_options=filters
			:id=pageid
			:searchbar=true
			:navbar=true
			:nav_items="['Inventory List', 'Edit Inventory List', 'Scan Item']"
			:nav_item_perms="['88','88','89']"
			:button_perm="'88'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0322'"
			:select_reroute=true
			:usePages=true
			:key=updateKey
			v-on:check="check"
			style="width:100%; height:calc(100vh);"
		></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.INVENTORY_PAGE,
			pageid2:PAGES.ADD_NEW_BOX_PAGE,
			filters:[
				{name:"Type", options:[
					"Empty",
					"Signal Cable and Wire",
					"Power Cables, Wires, Adapters",
					"Switchboard Electrical Component",
					"Switchboard Mechanical Component",
					"AMP Plug and Cable Part",
					"Meters",
					"Electronic Component",
					"Relay",
					"Document",
					"Hardware",
					"Protection Relay and Parts",
					"PLC and Parts",
					"Heat Shrink Tubing and Tape",
					"Battery",
					"Power supply and Inverter",
					"Emergency Stop",
					"Signal Connector",
					"Power Connector",
					"Test Probes and Leads",
					"Fuse",
					"Microcontroller, FPGA, Sensors",
					"Tool",
					"Server Parts",
					"Signal Adapter",
					"Transformer",
					"Smoke Test",
					"Sensor",
				], value:[
					false,false,false,false,false,false,false,
					false,false,false,false,false,false,false,
					false,false,false,false,false,false,false,
					false,false,false,false,false,false,false
				], permission:null},
				{name:"Description", options:["Empty","Not Empty"], value:[false,false], permission:null},
			],
			checkOpen:false,
			checkIsIn:false,
			updateKey:0,
			itemId:"",
			box_dialogue:false,
			box_dialog_text:'',
			box_id:null,
		}
	},
	methods:{
		closeCheck(){
			this.checkOpen=false;
		},
		check(isIn, itemId){
			this.itemId = itemId;
			this.checkIsIn=isIn;
			this.checkOpen=true;
		},
		checkItem(itemId){
			this.openBoxDialogue(itemId);
			this.updateKey++;
		},

		openBoxDialogue(itemId){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						itemId:itemId,
					}
				}
			).then((res) => {
				var boxId = res.data.data.column_data[0][0]
				if(boxId!="null") {
					this.box_id = boxId;
					this.box_dialogue_text = "Box "+boxId+" does not exist.\nCreate a new box?";
					this.box_dialogue = true;
				}
			});
		},
		cancelBox(){
			this.box_dialogue = false;
		},
		addBox(buttonName){
			if(buttonName=="Yes"){
				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid2,
							boxId:this.box_id,
						}
					}
				);
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Inventory.vue